export default import.meta.ROLLUP_FILE_URL_BAqkN8Mn;